import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import './RouteContextBar.css';
import { getRouteContext, normalizeNavigationPath } from './navigationMetadata';

export default function RouteContextBar() {
  const location = useLocation();
  const routeContext = getRouteContext(location.pathname);
  const isDashboard = normalizeNavigationPath(location.pathname) === '/';

  return (
    <nav className="routeContextBar" aria-label="Breadcrumb">
      <ol className="routeContextList">
        <li>
          {isDashboard ? (
            <span>Workspace</span>
          ) : (
            <Link to="/" title="Return to dashboard">Workspace</Link>
          )}
        </li>
        {!isDashboard && routeContext.section !== 'Workspace' && (
          <>
            <li className="routeContextSeparator" aria-hidden="true">
              <NavigateNextRoundedIcon />
            </li>
            <li className="routeContextSection">{routeContext.section}</li>
          </>
        )}
        <li className="routeContextSeparator" aria-hidden="true">
          <NavigateNextRoundedIcon />
        </li>
        <li className="routeContextCurrent" aria-current="page">{routeContext.name}</li>
      </ol>
    </nav>
  );
}
